/**
 * Launch workflow status for SiteGlue /onboard (Preview → Test → Go Live).
 * Persisted on SiteGlueOnboardSession.launchStatus.
 */

export type OnboardLaunchStatus = {
  previewCompleted: boolean;
  testCompleted: boolean;
  goLiveCompleted: boolean;
  meetBannerDismissed: boolean;
  /** True after build until user dismisses Meet banner or completes Preview. */
  postBuildPreviewPending: boolean;
};

export const DEFAULT_ONBOARD_LAUNCH_STATUS: OnboardLaunchStatus = {
  previewCompleted: false,
  testCompleted: false,
  goLiveCompleted: false,
  meetBannerDismissed: false,
  postBuildPreviewPending: false,
};

export function normalizeOnboardLaunchStatus(
  raw: Partial<OnboardLaunchStatus> | null | undefined,
): OnboardLaunchStatus {
  return {
    ...DEFAULT_ONBOARD_LAUNCH_STATUS,
    ...(raw && typeof raw === "object" ? raw : {}),
  };
}

/** Fresh post-build state: land on Preview with Meet banner. */
export function launchStatusAfterBuildComplete(): OnboardLaunchStatus {
  return {
    ...DEFAULT_ONBOARD_LAUNCH_STATUS,
    postBuildPreviewPending: true,
  };
}

export type LaunchNavGlyph = "pending" | "active" | "done";

export function launchNavGlyph(
  step: "preview" | "test" | "deploy",
  status: OnboardLaunchStatus,
  activeNav: string,
): LaunchNavGlyph {
  const isActive =
    activeNav === step ||
    (step === "deploy" && activeNav === "deploy") ||
    (step === "preview" && activeNav === "preview") ||
    (step === "test" && activeNav === "test");

  if (step === "preview") {
    if (status.previewCompleted) return "done";
    if (isActive) return "active";
    return "pending";
  }
  if (step === "test") {
    if (status.testCompleted) return "done";
    if (isActive) return "active";
    return "pending";
  }
  if (status.goLiveCompleted) return "done";
  if (isActive) return "active";
  return "pending";
}

export function launchSectionTitle(status: OnboardLaunchStatus): "LAUNCH" | "LIVE" {
  return status.goLiveCompleted ? "LIVE" : "LAUNCH";
}
